import { createSelector } from '@reduxjs/toolkit';
import { paymentsSelectors } from './reducer';

const orderHistoryObject = (state = {}) => state.order_history;

export const getLoading = createSelector(
  orderHistoryObject,
  (groupData) => groupData.ui.loading,
);

export const getOrderHistory = createSelector(
  orderHistoryObject,
  (orderHistoryObject) => orderHistoryObject.orders,
);

export const getPayments = createSelector(orderHistoryObject, (orderHistoryObject) =>
  paymentsSelectors.selectAll(orderHistoryObject.payments),
);

export const getLoadingOrders = createSelector(
  orderHistoryObject,
  (groupData) => groupData.ui.loadingOrderHistory,
);
